import React, { useState } from "react";
import {
  LayersControl,
  MapContainer,
  TileLayer,
  useMap,
  WMSTileLayer
} from "react-leaflet";
import "./style.scss";
import FormSearch from "./formSearch/index";
import { API_GEOSERVER_URI } from "../../api2";

export default function BanDo() {
  const [center, setCenter] = useState([11.988528, 108.933778]);
  const [zoom, setZoom] = useState(10);

  function ChangeView({ center, zoom }) {
    const map = useMap();
    map.setView(center, zoom);
    return null;
  }

  // const FlyToLocation = ({ valuePositionFly }) => {
  //     const map = useMap();
  //     useEffect(() => {
  //         if (valuePositionFly) {
  //             map.flyTo(valuePositionFly, 13, {
  //                 animate: true,
  //                 duration: 2 // Thời gian bay tới (tính bằng giây)
  //             });
  //         }

  //     }, [valuePositionFly, map]);
  // };

  return (
    <div style={{ height: "calc(100vh - 82px)" }}>
      <MapContainer
        scrollWheelZoom={true}
        zoomControl={true}
        maxZoom={18}
        minZoom={6}
        attributionControl={true}
        center={center}
        zoom={zoom}
        style={{ width: "100%", height: "100%", cursor: "default" }}
      >
        <ChangeView center={center} zoom={zoom} />
        <LayersControl position="topright">
          <LayersControl.Overlay checked name="Openstreetmap (tham khảo)">
            <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            type={"satellite"}
          />
          </LayersControl.Overlay>
          <WMSTileLayer
            maxZoom={30}
            layers={"nenbiendong"}
            params={{
              transparent: true,
              format: "image/png",
              tiled: true,
              SRS: "EPSG:9009113"
            }}
            url={"https://geoserver.cachinhbong.com/geoserver/CaChinhBong/wms"}
          ></WMSTileLayer>
          <LayersControl.Overlay name="Google Maps Vệ tinh (tham khảo)">
            <TileLayer
              attribution='&copy; <a href="https://www.google.com/maps">Google Maps</a>'
              url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
              type={"satellite"}
            />
          </LayersControl.Overlay>

          <LayersControl.Overlay checked name="DVHC cấp tỉnh">
            <WMSTileLayer
              maxZoom={30}
              layers={"kiem_ke_tnn:dvhccaptinhmoi"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                version: "1.1.0",
                SRS: "EPSG:4326"
              }}
              url={"https://kktnn.mae.gov.vn/geoserver/kiem_ke_tnn/wms"}
              crossOrigin="anonymous"
            ></WMSTileLayer>
          </LayersControl.Overlay>

          <LayersControl.Overlay checked name="Vùng sản xuất">
            <WMSTileLayer
              maxZoom={30}
              layers={"NhaDam:VungTrongNhaDam"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                version: "1.1.0",
                SRS: "EPSG:4326"
              }}
              url={"https://geoserver.cachinhbong.com/geoserver/NhaDam/wms"}
              crossOrigin="anonymous"
            ></WMSTileLayer>
          </LayersControl.Overlay>
        </LayersControl>
        <FormSearch setCenter={setCenter} setZoom={setZoom} />
      </MapContainer>
    </div>
  );
}
